export default __webpack_public_path__ + "static/similarity-do-caf5396cbe92865756efcc9a78bfaff0.png";